{
  "move_node": {
    "title": "Choisissez un nouvel emplacement pour le {{ nodeType }}",
    "multi_title": "Choisissez un nouvel emplacement pour les {{ count }} articles sélectionnés",
    "empty_title": "Choisissez un nouvel emplacement",
    "success": "Le ou les articles ont été déplacés avec succès.",
    "multiple_items": "Plusieurs articles",
    "no_permission_tooltip": "Vous n'êtes pas autorisé à déplacer des objets vers cet emplacement"
  },
  "permissions": {
    "request_access": "Demande d'accès",
    "no_read_permissions": "Vous n'êtes pas autorisé à lire cet article",
    "no_write_permissions": "Vous n'avez pas les droits d'écriture sur cet article"
  },
  "mappingLibraries": {
    "My Workspace": "Mon espace de travail",
    "My workspace": "Mon espace de travail",
    "Team Workspace": "Espace de travail d'équipe",
    "Team workspace": "Espace de travail d'équipe",
    "Shared library": "Espace de travail d'équipe",
    "Recently viewed": "Consulté récemment",
    "Recently Viewed": "Consulté récemment",
    "Favourites": "Favoris",
    "add_to_favourites": "ajouter aux favoris",
    "remove_from_favourites": "supprimer des favoris"
  },
  "copy_node": {
    "button": "Copiez {{ nodeType }}",
    "title": "Choisissez un emplacement pour copier le {{ nodeType }}",
    "multi_title": "Choisissez un emplacement pour copier les éléments sélectionnés",
    "empty_title": "Choisissez un lieu",
    "success": "Le ou les éléments ont été copiés avec succès.",
    "multiple_items": "Plusieurs articles",
    "no_permission_tooltip": "Vous n'êtes pas autorisé à copier des éléments vers cet emplacement",
    "copy_with_map_objects": "Copier les objets de la carte",
    "options_title": "Options de copie",
    "options_submit_button": "Copier",
    "options_description": {
      "map_objects_only": "Choisissez si vous souhaitez inclure des objets cartographiques lors de la copie.",
      "map_objects_and_permissions": "Choisissez d'inclure ou non les objets cartographiques et les autorisations lors de la copie."
    }
  },
  "delete_node": {
    "selected_items_cannot_be_deleted": "Vous ne pouvez pas supprimer le ou les éléments sélectionnés"
  },
  "create_node": {
    "change_location": "Changer de lieu"
  }
}